<template>
  <section class="sec-breadcrumb">
    <slot name="title">
      <h1 v-if="title" class="breadcrumb-ttl">
        {{ title }}
      </h1>
    </slot>
    <ul v-if="items && items.length" class="breadcrumb-nav">
      <template v-for="(item, index) in items">
        <li v-if="item.to" :key="`link-${index}`" class="breadcrumb-link">
          <router-link :to="item.to">{{ item.text }}</router-link>
        </li>
        <li v-else :key="`active-${index}`" class="breadcrumb-active">
          {{ item.text }}
        </li>
        <li v-if="index < items.length - 1" :key="`sep-${index}`" class="breadcrumb-separator">
          <app-icon name="chevron-right" size="14" />
        </li>
      </template>
    </ul>
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: "AppBreadcrumb",
  props: {
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    }
  }
};
</script>
